import { useEffect, useState } from "react";
import axios from "../../utils/axiosInstance";
import LinearLayout from "../../components/layout/LinearLayout";
import BasicInput from "../../components/edittext/basicInput/basicInput";

import { FaEdit, FaTrash } from "react-icons/fa";
import Modal from "../../components/modal/Modal";

import SelectBox from "../../components/edittext/selectbox/SelectBox";
import ButtonSimp from "../../components/button";

const Footer = () => {
  const [footer, setFooter] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [isSocial, setIsSocial] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [contact, setContact] = useState("");
  const [copyright, setCopyright] = useState("");
  const [links, setLinks] = useState([]);
  const [socialLinks, setSocialLinks] = useState([]);
  const [currentItem, setCurrentItem] = useState({
    label: "",
    url: "",
    icon: "",
    _id: null,
  });
  const socialarr = ["FaFacebook", "FaTwitter", "FaInstagram", "FaLinkedin"];

  // گرفتن اطلاعات اولیه
  useEffect(() => {
    axios.get("/footer").then((res) => {
      const data = res.data;
      setFooter(data);
      setTitle(data.title);
      setDescription(data.description);
      setContact(data.contact);
      setCopyright(data.copyright);
      // اضافه کردن _id موقت اگر موجود نیست
      setLinks(
        data.links.map((l) => ({
          ...l,
          _id: l._id || Date.now() + Math.random(),
        }))
      );
      setSocialLinks(
        data.socialLinks.map((s) => ({
          ...s,
          _id: s._id || Date.now() + Math.random(),
        }))
      );
    });
  }, []);

  const handleEdit = (
    item = { label: "", url: "", icon: "", _id: null },
    social = false
  ) => {
    setIsSocial(social);
    setCurrentItem(item);
    setModalOpen(true);
  };

  const handleSaveItem = () => {
    if (isSocial) {
      if (
        currentItem._id &&
        socialLinks.find((s) => s._id === currentItem._id)
      ) {
        setSocialLinks((prev) =>
          prev.map((s) => (s._id === currentItem._id ? currentItem : s))
        );
      } else {
        setSocialLinks((prev) => [
          ...prev,
          { ...currentItem, _id: Date.now() },
        ]);
      }
    } else {
      if (currentItem._id && links.find((l) => l._id === currentItem._id)) {
        setLinks((prev) =>
          prev.map((l) => (l._id === currentItem._id ? currentItem : l))
        );
      } else {
        setLinks((prev) => [...prev, { ...currentItem, _id: Date.now() }]);
      }
    }
    setModalOpen(false);
  };

  const handleDeleteItem = (item, social = false) => {
    if (social) {
      setSocialLinks((prev) => prev.filter((s) => s._id !== item._id));
    } else {
      setLinks((prev) => prev.filter((l) => l._id !== item._id));
    }
  };
  // حذف لینک‌ها
  const handleDeleteLink = (_id) => {
    setLinks((prev) => prev.filter((l) => l._id !== _id));
  };

  // حذف Social Links
  const handleDeleteSocial = (_id) => {
    setSocialLinks((prev) => prev.filter((s) => s._id !== _id));
  };

  const handleUpdateFooter = async () => {
    const footerData = {
      title,
      description,
      contact,
      copyright,
      links,
      socialLinks,
    };
    try {
      const res = await axios.put(`/footer/${footer._id}`, footerData);
      console.log("Footer updated:", res.data);
      alert("ذخیره شد ✅");
      setFooter(res.data.footer); // به‌روزرسانی state اصلی بعد از ذخیره
    } catch (err) {
      console.error(err);
      alert("خطا در ذخیره");
    }
  };

  if (!footer) return <div>Loading...</div>;

  return (
    <div>
      <LinearLayout orientation="vertical" margin={3}>
        <h2 className="text-xl font-bold mb-4">Manage Footer</h2>

        <BasicInput
          bsize="1"
          bcolor="primary"
          margin="2"
          bgcolor="white"
          textcolor="black"
          scolor="primary"
          value={title}
          onChange={(val) => setTitle(val)}
          text="Title"
        />
        <BasicInput
          bsize="1"
          bcolor="primary"
          margin="2"
          bgcolor="white"
          textcolor="black"
          scolor="primary"
          value={description}
          onChange={(val) => setDescription(val)}
          text="About Description"
        />
        <BasicInput
          bsize="1"
          bcolor="primary"
          margin="2"
          bgcolor="white"
          textcolor="black"
          scolor="primary"
          value={contact}
          onChange={(val) => setContact(val)}
          text="Contact"
        />
        <BasicInput
          bsize="1"
          bcolor="primary"
          margin="2"
          bgcolor="white"
          textcolor="black"
          scolor="primary"
          value={copyright}
          onChange={(val) => setCopyright(val)}
          text="Copyright"
        />

        <h3>Links</h3>
        <ButtonSimp
          margin="0"
          size="sm"
          font="0"
          color="primary"
          padding="1"
          text="Add Link"
          clicked={() => handleEdit({}, false)}
        />
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Link</th>
              <th>Edit</th>
            </tr>
          </thead>
          <tbody>
            {links.map((link, index) => (
              <tr key={link._id}>
                <td>{index + 1}</td>
                <td>{link.label}</td>
                <td>{link.url}</td>
                <td>
                  <button
                    onClick={() => handleEdit(link, false)}
                    className="btn btn-sm btn-warning me-1"
                  >
                    <FaEdit />
                  </button>
                  <button
                    onClick={() => handleDeleteLink(link._id)}
                    className="btn btn-sm btn-danger"
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <h3>Social Links</h3>
        <ButtonSimp
          margin="0"
          size="sm"
          font="0"
          color="primary"
          padding="1"
          text="Add Social"
          clicked={() => handleEdit({}, true)}
        />
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th>#</th>
              <th>Url</th>
              <th>Icon</th>
              <th>Edit</th>
            </tr>
          </thead>
          <tbody>
            {socialLinks.map((s, index) => (
              <tr key={s._id}>
                <td>{index + 1}</td>
                <td>{s.url}</td>
                <td>{s.icon}</td>
                <td>
                  <button
                    onClick={() => handleEdit(s, true)}
                    className="btn btn-sm btn-warning me-1"
                  >
                    <FaEdit />
                  </button>
                  <button
                    onClick={() => handleDeleteSocial(s._id)}
                    className="btn btn-sm btn-danger"
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <ButtonSimp
          margin="0"
          size="sm"
          font="0"
          color="primary"
          padding="1"
          text="Save All"
          clicked={handleUpdateFooter}
        />
      </LinearLayout>

      <Modal show={modalOpen} modalClosed={() => setModalOpen(false)}>
        <LinearLayout orientation="vertical">
          {isSocial ? (
            <>
              <BasicInput
                bsize="1"
                bcolor="primary"
                margin="2"
                bgcolor="white"
                textcolor="black"
                scolor="primary"
                text="URL"
                value={currentItem.url}
                onChange={(val) => setCurrentItem({ ...currentItem, url: val })}
              />
              <SelectBox
                value={currentItem.icon}
                array={socialarr}
                onChange={(val) =>
                  setCurrentItem({ ...currentItem, icon: val })
                }
                text="Social Network"
              />
            </>
          ) : (
            <>
              <BasicInput
                bsize="1"
                bcolor="primary"
                margin="2"
                bgcolor="white"
                textcolor="black"
                scolor="primary"
                text="Name"
                value={currentItem.label}
                onChange={(val) =>
                  setCurrentItem({ ...currentItem, label: val })
                }
              />
              <BasicInput
                bsize="1"
                bcolor="primary"
                margin="2"
                bgcolor="white"
                textcolor="black"
                scolor="primary"
                text="Link"
                value={currentItem.url}
                onChange={(val) => setCurrentItem({ ...currentItem, url: val })}
              />
            </>
          )}
          <LinearLayout orientation="horizontal" gap={3}>
            <ButtonSimp
              margin="0"
              size="sm"
              font="0"
              color="primary"
              padding="1"
              text="Save"
              clicked={handleSaveItem}
            />
            <ButtonSimp
              margin="0"
              size="sm"
              font="0"
              color="danger"
              padding="1"
              text="Cancel"
              clicked={() => setModalOpen(false)}
            />
          </LinearLayout>
        </LinearLayout>
      </Modal>
    </div>
  );
};

export default Footer;
